unit ChargeItemType;
{

/* property DeviceType added. */

/* Initial. */

}
interface

type
  TChargeItemType = class
  private
    fStatusDate: String;
    fDeviceType: String;
    fDeviceName: String;
    fCharge: String;
    fNetName: String;
    fNetNumber: String;
    fStatusBy: String;
  published
    property StatusDate: String read fStatusDate;
    property DeviceType: String read fDeviceType;
    property DeviceName: String read fDeviceName;
    property Charge: String read fCharge;
    property NetName: String read fNetName;
    property NetNumber: String read fNetNumber;
    property StatusBy: String read fStatusBy;
  end;

implementation

end.
